import React from 'react';
import Button, { ButtonProps } from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';

type LinkButtonProps =
  Omit<
  ButtonProps,
  'bsPrefix' | 'as'> & {
      to?: string;
      as: 'a' | 'Link';
      target?: React.HTMLAttributeAnchorTarget;
  };

const LinkButton = (props: LinkButtonProps) => {
    const {
        target,
        variant,
        className,
        href,
        to,
        as,
        onClick,
        ...rest
    } = props;

    if (as === 'a') {
        return (
            <Button
                as='a'
                href={href}
                target={target}
                variant={variant || 'nmi-primary'}
                className={className}
                onClick={onClick}
                {...rest}
            />
        );
    }

    return (
        <Link to={String(to)}>
            <Button
                variant={variant || 'nmi-primary'}
                className={className}
                onClick={onClick}
                {...rest}
            />
        </Link>
    );
};

export default LinkButton;
